import * as React from 'react';
import { styled } from '@mui/material/styles'
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import ReactMarkdown from 'react-markdown';


export default function RelationsInfo( {content} ) {
    return(
        <Box sx={{
            // height: '500px',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
        }}>
            <Typography 
            color='white'
            component="h2"
            variant="subtitle3"
            sx={{ 
                placeSelf: 'start',
                fontWeight: '600', 
                padding: '5px',
                textShadow: '2px 2px 6px black' }}>
                Insight into the relationship
            </Typography>
            <Typography
                color='white'
                component="h3"
                sx={{ 
                    fontWeight: '500',
                    textShadow:'1px 1px 3px black' }}>
                <ReactMarkdown>
                    {content?content: 'Brak wspólnej interakcji'}
                </ReactMarkdown>
                
            </Typography>
        </Box>
    );
}